<template>
  <drag-modal :title="$t('page_my_document_advanced')" :subTitle="`(${subTitle})`" :visible="visible" top="122px" width="450px" @close="onClose">
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
      <a-form-item :label="$t('region')">
        <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            allowClear
            :placeholder="$t('please_select') + $t('region')"
            v-model="formData.areaId"
            @change="handleAreaChange"
        >
          <a-select-option
              :key="i.code"
              :value="i.code"
              v-for="i in regionList"
          >
            {{ i.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_province')">
        <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            v-model="formData.provinceId"
            allowClear
            show-search
            optionFilterProp="children"
            :placeholder="$t('page_ops_customer_select_province')"
            @change="handleProvinceChange"
        >
          <a-select-option
              :key="i.code"
              :value="i.code"
              v-for="i in provinceList"
          >
            {{ i.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_city')">
        <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            v-model="formData.cityId"
            allowClear
            show-search
            optionFilterProp="children"
            :placeholder="$t('page_ops_customer_select_city')"
            @change="handleCityChange"
        >
          <a-select-option :key="i.code" :value="i.code" v-for="i in cityList">
            {{ i.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_material_customer_name')">
        <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            v-model="formData.customerId"
            allowClear
            show-search
            optionFilterProp="children"
            :placeholder="$t('page_material_customer_name')"
            @change="changeCustomer"
        >
          <a-select-option :key="i.id" v-for="i in customerList">
            {{ i.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_work_record_engineer')">
        <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            v-model="formData.claimUser"
            allowClear
            show-search
            optionFilterProp="children"
            :placeholder="$t('page_work_record_engineer')"
        >
          <a-select-option :key="i.id" v-for="i in userList">
            {{ i.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_work_record_customer_request')">
        <a-input v-model="formData.request" :placeholder="$t('common_please_input') + $t('page_ops_work_record_customer_request')"/>
      </a-form-item>
      <a-form-item
          :label="$t('page_work_record_involved_machine')"
          prop="isInvolvedMachine"
      >
        <a-radio-group name="radioGroup" v-model="formData.isInvolvedMachine" @change="onInvolvedMachineChange">
          <a-radio value="">
            {{ $t("page_all") }}
          </a-radio>
          <a-radio :value="1">
            {{ $t("yes") }}
          </a-radio>
          <a-radio :value="0">
            {{ $t("no") }}
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-if="formData.isInvolvedMachine !== 0" :label="$t('page_ops_work_record_device_type')">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          v-model="formData.deviceTypeIds"
          mode="multiple"
          :placeholder="$t('please_select') + $t('page_ops_work_record_device_type')"
        >
          <a-select-option :value="item.id" :key="item.id" v-for="(item) in deviceTypes">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="formData.isInvolvedMachine !== 0" :label="$t('page_extranet_Machine_serial_number')">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          v-model="formData.workStationId"
          :placeholder="$t('please_select') + $t('page_extranet_Machine_serial_number')"
        >
          <a-select-option :value="item.id" :key="item.id" v-for="(item) in deviceSerials">
            {{item.serialNo}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('time')">
        <a-range-picker style="width: 100%"
          v-model="formData.time"
          show-time
          :placeholder="[$t('please_select') + $t('time'),$t('please_select') + $t('time')]"
          valueFormat = 'YYYY-MM-DD HH:mm:ss'
          format="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_work_record_submit_person')">
        <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            show-search
            optionFilterProp="children"
            v-model="formData.submitUserId" :placeholder="$t('please_select') + $t('page_ops_work_record_submit_person')" allowClear>
          <a-select-option :value="item.id" :key="item.id" v-for="(item) in users">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_work_record_contact_person')">
        <a-input v-model="formData.contactUserName" :placeholder="$t('common_please_input') + $t('page_ops_work_record_contact_person')" />
      </a-form-item>
    </a-form>
    <div style="text-align:center;padding-bottom:10px;" slot="footer">
      <a-button :loading="loading" @click="save" type="primary">{{$t('common_search')}}</a-button>
      <a-button :loading="loading" @click="onReset" style="margin-left: 10px;" type="default">{{
          $t('common_reset')
        }}</a-button>
    </div>
  </drag-modal>
</template>
<script>
import { RegionServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
const rsp = new RegionServiceProxy()
import { DeviceTypeServiceProxy, DeviceTypePageDTO, Query, MachineServiceProxy} from '@/service-proxies/app-v2/workStation.service-proxies'
const deviceTypeSrvProxy = new DeviceTypeServiceProxy()
import {UserServiceProxy} from "@/service-proxies/app-v2/user.service-proxies"
import {CustomerServiceProxy} from "@/service-proxies/app-v2/client.service-proxies";
import {MasterlinkUserServiceProxy} from "@/service-proxies/app-v2/user.service-proxies";
const userServiceProxy = new UserServiceProxy()
const customerService = new CustomerServiceProxy();
const userService = new MasterlinkUserServiceProxy();
const machineService = new MachineServiceProxy();

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: Object,
    subTitle: String,
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      treeData: [],
      regionList: [],
      provinceList: [],
      cityList: [],
      deviceTypes: [],
      customerList: [],
      users:[],
      userList: [], // 工程师列表
      deviceSerials: []
    }
  },
  async created() {
    await this.getAreaList();
    await this.getUserList();
    await this.getCustomerList();
    await this.getUser();
    await this.getDeviceTypes();
    await this.getDeviceSerials();
  },
  methods: {
    changeCustomer(value) {
      this.getDeviceSerials(value);
      this.formData.workStationId = '';
    },
    getDeviceSerials(customerId) {
      machineService.getAllMachineSelectList(customerId, '', '').then(res=>{
        this.deviceSerials = res || [];
      })
    },
    onInvolvedMachineChange(e) {
      const {value} = e.target;
      if(value === 0) {
        this.formData.deviceTypeIds = [];
        this.formData.workStationId = '';
      }
    },
    getUser() {
      userService.getProcessPostUserList({name: "", dataScope: ""}).then(res=>{
        this.userList = res.data;
      })
    },
    getCustomerList(params) {
      const defalut = {areaName: this.formData.areaName, provinceName: this.formData.provinceName, cityName: this.formData.cityName};
      const p = {...defalut, ...params}
      customerService.getAllCustomerSelectList(p).then((res) => {
        this.customerList = res.map(v=>{
          return {id: v.id, name: v.name}
        });
      });
    },
    handleCityChange(value) {
      this.formData.cityName = this.cityList.find(v=>v.code === value)?.name || '';
      this.getCustomerByArea({cityName: this.formData.cityName});
    },
    getCityList(value) {
      rsp.select(value).then(res=>{
        this.cityList = res.data;
      })
    },
    handleAreaChange(value) {
      this.formData.areaName = this.regionList.find(v=>v.code === value)?.name || '';
      this.formData.provinceId = '';
      this.formData.cityId = '';
      this.formData.provinceName = '';
      this.formData.cityName = '';
      this.provinceList = [];
      this.cityList = [];
      this.getCustomerByArea({areaName: this.formData.areaName});
      if(value) {
        rsp.select(value).then(res=>{
          this.provinceList = res.data;
        })
      }
    },
    handleProvinceChange(value) {
      this.formData.provinceName = this.provinceList.find(v=>v.code === value)?.name || '';
      this.formData.cityId = '';
      this.formData.cityName = '';
      this.cityList = [];
      this.getCustomerByArea({provinceName: this.formData.provinceName});
      this.getCityList(value)
      this.formData.provinceId = value;
    },
    getCustomerByArea(params) {
      this.getCustomerList(params);
      this.formData.customerId = '';
      this.formData.workStationId = '';
    },
    onReset(){
      this.form.resetFields()
      this.$emit('reset')
    },
    getDeviceTypes(){
      const pageDto = new DeviceTypePageDTO();
      pageDto.query = new Query();
      pageDto.query.current=1;
      pageDto.query.size=-1;

      deviceTypeSrvProxy.pageDeviceType(pageDto)
          .then(res=>{
            this.deviceTypes = res.records;
          });
    },
    async getUserList(){
      this.users = await (await userServiceProxy.userList()).data
    },
    async getAreaList() {
      this.regionList = await (await rsp.select()).data
    },
    onClose() {
      this.form.resetFields();
      this.$emit("close");
    },
    save() {
      const {time} = this.formData;
      if(time){
        this.formData.startTime = time[0];
        this.formData.endTime = time[1];
      }
      this.$emit("advanceSearch", this.formData);
    },
  },
};
</script>
<style></style>
